import {createContext, ReactNode, useContext, useEffect, useRef, useState} from "react";
import "./steps-process.css";
import {FormValuesProps} from "../modals/notificationModals/NewNotificationModal";
import StepsTracker from "../messageCreationFlow/steps-tracker/StepsTracker";
import { StepsContext } from "../../context/StepsContext";

export interface StepsProps {
    title: string;
    icon?: any;
}

interface StepsProcessProps {
    children: ReactNode[];
    steps: StepsProps[];
    hideStepsTracker?: boolean;
    onFirstSentenceBack?: () => void;
    stepWidth?: number;
    initialStep?: number;
    showProgressCircles?: boolean;
    className?: string;
}

const STEP_WIDTH = 957;

const StepsProcess = ({ initialStep = 1, children, steps, hideStepsTracker = false, onFirstSentenceBack, stepWidth = STEP_WIDTH, showProgressCircles = true, className = '' }: StepsProcessProps) => {

    const scrollerRef = useRef<HTMLDivElement>(null);
    const smoothAnimation = useRef(true);
    const [step, setStep] = useState(1);
    const [stepsDone, setStepsDone] = useState(0);
    const ranRef = useRef(false);

    const goToStep = (nextStep: number) => {
        setStep(nextStep);
    }

    const goBack = () => {
        const nextStep = step - 1;
        if(nextStep < 1) {
            onFirstSentenceBack && onFirstSentenceBack();
        } else {
            setStep(nextStep);
        }
    }

    const goNext = (withAnimation: boolean = true) => {
        smoothAnimation.current = withAnimation;
        setStepsDone(step + 1);
        setStep(step + 1);
    }

    const scrollToStep = () => {
        if(scrollerRef.current) {
            scrollerRef.current.style.setProperty('left', `${(step-1)*(-stepWidth)}px`);
        }
    }

    useEffect(() => {
        scrollToStep();
    }, [step]);

    useEffect(() => {
        setStep(initialStep);
    }, [initialStep]);

    return (
        <div className={`steps-process-container ${className}`}>
            <StepsContext.Provider value={{ goBack, goNext, currentStep: step, goToStep }}>
                {!hideStepsTracker ? <StepsTracker steps={steps} step={step} stepsDone={stepsDone} setStep={setStep} showProgressCircles={showProgressCircles} /> : null}
                <div id="steps-scroller" className="steps-scroller" style={{ width: `${stepWidth}px`}}>
                    <div ref={scrollerRef} className={`steps-container ${smoothAnimation.current ? 'smooth' : ''}`} style={{ width: `${stepWidth * children.length}px` }}>
                        {children}
                    </div>
                </div>
            </StepsContext.Provider>
        </div>
    )
}

export default StepsProcess;